/**
 * Format a number as currency in Euro
 * @param amount The amount to format
 * @returns The formatted amount
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
};

/**
 * Format a date in the specified locale format
 * @param date The date to format
 * @param locale The locale to use (default: nl-NL)
 * @returns The formatted date
 */
export const formatDate = (date: string, locale = 'nl-NL'): string => {
  return new Date(date).toLocaleDateString(locale);
};

/**
 * Truncate a string if it exceeds the given length
 * @param str The string to truncate
 * @param maxLength The maximum length allowed
 * @returns The truncated string
 */
export const truncateString = (str: string, maxLength: number): string => {
  if (str.length <= maxLength) return str;
  return str.slice(0, maxLength) + '...';
};

/**
 * Calculate the total price of an order based on products and quantities
 * @param products Array of products with prices and quantities
 * @returns The total price
 */
export const calculateTotal = (
  products: Array<{ prijs_per_stuk: number; hoeveelheid: number }>
): number => {
  return products.reduce((sum, item) => sum + item.prijs_per_stuk * item.hoeveelheid, 0);
};

/**
 * Generate a filename safe version of a string (for downloads)
 * @param str The string to make filename safe
 * @returns A filename safe string
 */
export const toFilenameString = (str: string): string => {
  return str
    .replace(/[^a-z0-9]/gi, '_')
    .toLowerCase()
    .replace(/_+/g, '_');
}; 